import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["serviceInput", "serviceList", "continueBtn"]

  connect() {
    this.validateServices()
    if (this.hasServiceInputTarget) this.serviceInputTarget.addEventListener("input", () => this.validateServices())
    if (this.hasServiceListTarget) this.serviceListTarget.addEventListener("input", () => this.validateServices())
    // If you allow adding/removing services dynamically, listen for DOM changes
    if (this.hasServiceListTarget) {
      const observer = new MutationObserver(() => this.validateServices())
      observer.observe(this.serviceListTarget, { childList: true, subtree: true })
    }
  }

  validateServices() {
    // Check if at least one non-empty service is present
    let valid = false
    if (this.hasServiceListTarget) {
      const serviceItems = this.serviceListTarget.querySelectorAll('input[name^="services"]')
      valid = Array.from(serviceItems).some(input => input.value.trim().length > 0)
    } else if (this.hasServiceInputTarget) {
      valid = this.serviceInputTarget.value.trim().length > 0
    }
    if (this.hasContinueBtnTarget) {
      this.continueBtnTarget.disabled = !valid
    }
  }
}
